<template>
  <button type="button" class="button load-more-btn" @click="loadMore">
    <strong>{{text}}</strong>
  </button>
</template>

<script>
export default {
  name: 'LoadMoreBtn',
  props: {
    text: String
  },
  methods: {
    loadMore () {
      this.$emit('loadMore')
    }
  }
}
</script>

<style lang="scss" scoped>
.load-more-btn {
  @include respond-to(desktop) {
    width: 184px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadMoreBtn.vue